
import React, { Component, useState } from 'react';
import { render } from 'react-dom';


function MultipleProgressBar (props) {

  const [hovor, setHovor] = useState(false)

  
    return (

      <div className="progress" style={{backgroundColor:hovor?"#e1d7d7":"white", height:'2rem', padding:'10px'}}  onMouseEnter={()=>{setHovor(true)}} onMouseLeave={()=>{setHovor(false)}}>
        {props.children}
      </div>
    )
  
}

export default  MultipleProgressBar;